import { ResponsiveLine } from '@nivo/line';
import { useMemo } from 'react';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { BarDataItem } from '../../types';

interface Props {
  data: BarDataItem[];
}

const GraphLineSchedules = ({ data }: Props) => {
  const theme = useTheme();
  const { t } = useTranslation();

  // Converter dados do formato de barras para o formato do @nivo/line
  const lineData = useMemo(() => {
    if (!data || data.length === 0) return [];

    return [
      {
        id: t('totalVisits') as string,
        data: data.map((item) => ({
          x: item.date,
          y: item.visits,
        })),
      },
    ];
  }, [data]);

  return (
    <ResponsiveLine
      data={lineData}
      margin={{ top: 20, right: 10, bottom: 60, left: 50 }}
      animate
      enableSlices="x"
      xScale={{ type: 'point' }}
      yScale={{
        type: 'linear',
        min: 'auto',
        max: 'auto',
        stacked: false,
        reverse: false,
      }}
      axisTop={null}
      axisRight={null}
      axisBottom={{
        tickRotation: -45,
      }}
      axisLeft={{
        tickRotation: 0,
        format: (v) => (Number.isInteger(v) ? v : ''),
      }}
      pointSize={6}
      pointColor={{ theme: 'background' }}
      pointBorderWidth={2}
      pointBorderColor={{ from: 'serieColor' }}
      pointLabelYOffset={0}
      enableCrosshair
      enableArea
      areaOpacity={0.15}
      layers={[
        'grid',
        'markers',
        'areas',
        'lines',
        'slices',
        'axes',
        'points',
        'legends',
        'mesh',
        'crosshair',
      ]}
      useMesh
      colors={[theme.colors.primaryMedium || '#6c63ff']}
      legends={[
        {
          anchor: 'top-left',
          direction: 'row',
          justify: false,
          translateX: -1,
          translateY: -20,
          itemWidth: 100,
          itemHeight: 10,
          itemsSpacing: 0,
          symbolSize: 11,
          symbolShape: 'circle',
          itemDirection: 'left-to-right',
          itemTextColor: theme.colors.onBackground,
          itemOpacity: 0.7,
          effects: [
            {
              on: 'hover',
              style: {
                itemOpacity: 1,
              },
            },
          ],
        },
      ]}
      theme={{
        textColor: theme.colors.onBackground,
        grid: {
          line: {
            stroke: theme.colors.onBackground + '30',
            strokeWidth: 0.5,
          },
        },
        crosshair: {
          line: {
            stroke: theme.colors.onBackground,
            strokeWidth: 1,
            strokeOpacity: 0.75,
            strokeDasharray: '6 6',
          },
        },
        tooltip: {
          container: {
            background: theme.colors.surface,
            color: theme.colors.onSurface,
            borderRadius: '0.75rem',
            boxShadow: '0 1px 2px rgba(0, 0, 0, 0.25)',
            padding: '5px 9px',
          },
        },
      }}
    />
  );
};

export default GraphLineSchedules;
